import React from "react";
import { estimationColumns, resultColumns } from "./columnsData/columns";
import { useFormContext, useWatch } from "react-hook-form";
import {
  compactTableProps,
  smallerHeadCellProps,
} from "../../../../../../styles/muiProps";
import { Button, Grid } from "@mui/material";
import {MaterialReactTable} from "material-react-table";
import axios from "../../../../../../api/axios";
import { createShellTasks } from "../../../../../../api/tasksApi";

// Edge Mentor code labels for the Shell Estimation table (DataGridView7).
// These semantic labels match the Edge Mentor Excel/runtime content.
const SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS = {
  Circ_Weld_Hours: "shellEstCircWeldHours",
  Long_Weld_Hours: "shellEstLongWeldHours",
  Rolling_Hours: "shellEstRollingHours",
  Dishing_Hours: "shellEstDishingHours",
  NDT_Cost: "shellEstNdtCost",
};

const EstimationTable = (props) => {
  const { isLoading, projectId, equipId } = props;
  const { control, getValues } = useFormContext();
  const watchedRows = useWatch({
    control,
    name: "DataGridView7",
  });

  const addToTasks = async () => {
    const inputRaw = getValues("DataGridView5");
    const estimation = getValues("DataGridView7");
    // Strip UID before sending to tasks API
    const input = inputRaw?.map((row) => {
      const { UID, ...rest } = row;
      return rest;
    });
    let subCategoryRequest = {
      subCategory: {
        name: "",
        estimatedHours: 0,
        remarks: "",
        invoiceable: false,
        // categoryId: row.id
      },
      users: [],
    };
    console.log(input);
    let categoryRequest = {
      name: "Shell Welding",
      mcsProjectId: projectId,
      // tasks: data
    };

    await createShellTasks(input, estimation, projectId, equipId);
  };

  return (
    <MaterialReactTable
      columns={estimationColumns}
      data={watchedRows ?? []}
      {...compactTableProps}
      {...smallerHeadCellProps}
      enableColumnActions={false}
      // enableRowActions={false}
      enableEditing={true}
      editDisplayMode={"cell"}
      initialState={{ density: "compact" }}
      state={{
        isLoading: isLoading,
      }}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid rgba(224,224,224,1)",
          backgroundColor: "hsla(250, 86%, 97%, 1)",
          fontSize: "16px",
          // Header 17px taller overall vs the default (23.7px per side).
          py: "23.7px",
        },
      })}
      muiTableBodyCellProps={({ cell }) => ({
        // Keep calculated/read-only estimation cells message-capable.
        // This marker is detected by the existing PV-wide EdgeMentorHost.
        "data-edge-mentor":
          SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS[cell.column.id] || undefined,
        sx: {
          textAlign: "center",
          borderRight: "1px solid #ddd",
          // Fixed height + vertical centering for uniform rows,
          // matching the calculation table.
          height: "45px",
          padding: "0 8px",
          verticalAlign: "middle",
        },
      })}
      muiTableBodyRowProps={{
        sx: { height: "45px" },
      }}

      renderBottomToolbarCustomActions={() => (
        <Button
          color="secondary"
          onClick={() => addToTasks()}
          variant="contained"
          size="small"
        >
          Add to Tasks
        </Button>
      )}
    />
  );
};

export default EstimationTable;
